import { createFeaturesApi } from './features.js';
import { createAuthApi } from './auth.js';
import { createPaymentsApi } from './payments.js';
import { createProfileApi } from './profile.js';
import { createSharingApi } from './sharing.js';
import { createProjectApi } from './project.js';
import { createFundApi } from './fund.js';
import { createNewsApi } from './news.js';
import { createUnsubscribeApi } from './unsubscribe.js';
import { createMarketingApi } from './marketing.js';
import { createPulseApi } from './pulse.js';

export function createApiConfig(baseUrl) {
  return {
    ...createFeaturesApi(baseUrl),
    ...createAuthApi(baseUrl),
    ...createPaymentsApi(baseUrl),
    ...createProfileApi(baseUrl),
    ...createSharingApi(baseUrl),
    ...createProjectApi(baseUrl),
    ...createFundApi(baseUrl),
    ...createNewsApi(baseUrl),
    ...createUnsubscribeApi(baseUrl),
    ...createMarketingApi(baseUrl),
    ...createPulseApi(baseUrl),
  };
}
